define( [
	"./document"
], function( document ) {
	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/documentElement.js
// module id = 553
// module chunks = 352